<!--
 * @Descripttion: 虚拟建造忘记密码验证组件
 * @version: 3.0
 * @Author: zhangfan
 * @email: 2207044692@qq.com
 * @Date: 2024-11-27 17:21:16
 * @LastEditors: zouxin
 * @LastEditTime: 2025-01-16 08:58:56
-->
<template>
  <div class="login-form-wrapper">
    <a-form-model :model="form" :rules="rules" ref="loginForm" layout="vertical" class="login-form">
      <a-form-model-item prop="firstPassword">
        <a-input-password
          :placeholder="$t('base.pleaseInputNewPassword')"
          v-model="form.firstPassword"
          allow-clear
          hide-button
        ></a-input-password>
      </a-form-model-item>

      <a-form-model-item prop="secondPassword" style="margin-top: 10px">
        <a-input-password :placeholder="$t('base.confirmNewPassword')" v-model="form.secondPassword" allow-clear>
        </a-input-password>
      </a-form-model-item>

      <a-form-model-item prop="phoneNumber">
        <a-input
          :placeholder="$t('base.phoneNumber')"
          v-model="form.phoneNumber"
          @blur="getBicueUserInfo()"
          allow-clear
          hide-button
        ></a-input>
      </a-form-model-item>

      <a-form-model-item prop="code" style="margin-top: 10px">
        <a-input
          :placeholder="$t('base.code')"
          class="codeInput"
          style="width: 100%; height: 40px"
          v-model="form.code"
          allow-clear
          hide-button
        >
          <template #suffix>
            <div
              class="send-code"
              style="width: 100%; height: 100%; font-size: 14px; color: #0166fc"
              v-if="!isCountingDown"
              @click="sendCode"
            >
              {{ $t('base.getCode') }}
            </div>
            <div v-else style="width: 100%; height: 100%; font-size: 14px; color: #a2a5ae">
              {{ countdown }}{{ $t('base.afterSecondResend') }}
            </div>
          </template>
        </a-input>
      </a-form-model-item>

      <div class="register-box">
        <div class="register-code">
          <a
            href="https://ucnu9t4fowy8.feishu.cn/wiki/Jr8MwN6SniPn4KkrVQ6cbgMCnmc#share-Rxv5dW7BSoIalXx2QvacUQNvnBg"
            target="_blank"
          >
            {{ $t('base.noCode') }}
          </a>
        </div>
      </div>
      <a-button type="primary" class="sbmitBtn" @click.native="skipToResetPwdPage">{{ $t('base.confirm') }}</a-button>
    </a-form-model>
  </div>
</template>

<script>
// 引入API
import { sendCaptcha, resetPassword, getSecret, getBicubeUserInfobyPhone } from '@/api/user' // 需要创建相应的API
import aes from '@/utils/aes'

export default {
  data() {
    return {
      form: {
        phoneNumber: '',
        code: '',
        firstPassword: '',
        secondPassword: '',
      },
      countdown: 0,
      errorMessage: '',
      loading: false,
      userName: '',
      secret: '',
      timestamp: '',
    }
  },
  computed: {
    isAgree() {
      return this.$store.getters.LoginInfo.isAgree
    },
    isCountingDown() {
      return this.countdown > 0 || false
    },
    rules() {
      return {
        phoneNumber: [
          { required: true, message: this.$t('base.pleaseInputPhoneNumber'), trigger: 'blur' },
          { validator: this.validatePhone, trigger: 'blur' },
        ],
        code: [{ required: true, message: this.$t('base.pleaseInputCode'), trigger: 'blur' }],
        firstPassword: [
          { required: true, message: this.$t('base.pleaseSetNewPassword'), trigger: 'blur' },
          { validator: this.validateFirstPassword, trigger: 'blur' },
        ],
        secondPassword: [
          { required: true, message: this.$t('base.pleaseConfirmNewPassword'), trigger: 'blur' },
          { validator: this.validateSecondPassword, trigger: 'blur' },
        ],
      }
    },
  },
  mounted() {
    // 获取基础平台密匙
    this.getSecret()
  },
  methods: {
    // 获取secret和secretTimestamp
    async getSecret() {
      const res = await getSecret()
      if (res.status === 0) {
        this.secret = res.data.secret
        this.timestamp = res.data.timestamp
      } else {
        this.$message.error('获取失败')
      }
    },

    // 验证手机号
    validatePhone(rule, value, callback) {
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(value)) {
        callback(new Error(this.$t('base.phoneNumberError')))
      } else {
        callback()
      }
    },

    // 验证新密码
    validateFirstPassword(rule, value, callback) {
      // 密码必须包含字母、数字、特殊字符中的至少三种，且长度不少于8位
      const passwordValidate =
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-])[A-Za-z\d@$!%*?&#^(){}=+`~/！|,.\[\];'":、—_<>《》：“-]{8,}$/
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (!passwordValidate.test(value)) {
        callback(new Error(this.$t('base.passwordRule', [8])))
      } else if (this.form.secondPassword && this.form.secondPassword !== value) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    },

    // 验证确认密码
    validateSecondPassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.firstPassword) {
        callback(new Error('两次密码不一致'))
      } else {
        callback()
      }
    },

    // 通过手机号查询基础平台用户信息
    async getBicueUserInfo() {
      const phone = this.form.phoneNumber
      const phoneNumberValidate = /^1((34[0-8])|(8\d{2})|(([35][0-35-9]|4[579]|66|7[35678]|9[1389])\d{1}))\d{7}$/
      if (!phoneNumberValidate.test(phone)) return
      const res = await getBicubeUserInfobyPhone(phone)
      if (res.code == 200) {
        this.userName = res.result.applyAccount
      } else {
        this.$message.error('获取虚拟建造账号信息失败')
      }
    },

    // 获取验证码
    async sendCode() {
      const phoneReg = /^1[3456789]\d{9}$/
      if (!phoneReg.test(this.form.phoneNumber)) {
        this.$message.warning('请输入正确的手机号！')
        return
      }
      this.loading = true
      try {
        const params = {
          telephone: this.form.phoneNumber,
          secretKey: 'auth_forget_password_code',
        }
        const res = await sendCaptcha(params)
        console.log(res, '422222222222')
        if (res.status === 0) {
          this.$message.success('验证码发送成功！')
          this.startCountdown()
        } else {
          this.$message.error(res.message || '验证码发送失败！')
        }
      } catch (error) {
        // console.log(error, 'error')
        // this.$message.error(error.message || '验证码发送失败！')
      } finally {
        // this.loading = false
      }
    },

    // 重置密码
    async skipToResetPwdPage() {
      try {
        await this.$refs.loginForm.validate()
        this.loading = true
        const params = {
          secretKey: 'auth_forget_password_code',
          password: aes.encrypt(this.form.firstPassword, 'cbim2192cbim2192'),
          confirmPassWord: aes.encrypt(this.form.secondPassword, 'cbim2192cbim2192'),
          telephone: this.form.phoneNumber,
          inputCode: this.form.code,
          userId: this.userName,
          secretTimestamp: this.timestamp,
        }
        console.log(params, '这里是密码重置参数')
        const res = await resetPassword(params)
        if (res.status === 0) {
          this.$message.success('密码重置成功！')
          // 重置成功后跳转到登录页
          setTimeout(() => {
            this.$router.push('/login')
          }, 1500)
        } else {
          this.$message.error(res.message || '密码重置失败！')
        }
      } catch (error) {
        // if (error.message) {
        //   this.$message.error(error.message)
        // }
      } finally {
        // this.loading = false
      }
    },

    // 启动倒计时
    startCountdown() {
      const TIME_COUNT = 60
      this.countdown = TIME_COUNT
      const interval = setInterval(() => {
        if (this.countdown > 0 && this.countdown <= TIME_COUNT) {
          this.countdown -= 1
        } else {
          clearInterval(interval)
        }
      }, 1000)
    },

    // 跳转到注册页面
    skipToRegisterPage() {
      this.$router.push({
        path: '/register',
      })
    },
  },
  created() {
    // this.loginStore = useLoginInfo()
    // this.userStore = useUserStore()
  },
}
</script>

<style lang="less" scoped>
.login-form {
  margin-top: 20px;
  font-size: 18px;

  .incocss {
    font-size: 18px;
    margin-right: 3px;
  }

  &-wrapper {
    width: 360px;
    color: #fff;
  }

  /deep/.ant-input {
    height: 40px;
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus {
      box-shadow: none;
    }
  }

  /deep/.ant-select-selector {
    background-color: #222222 !important;
    border: none !important;
    border-radius: 8px !important;
  }

  /deep/.ant-input-affix-wrapper {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    &:focus,
    &-focused {
      box-shadow: none;
    }

    .ant-input {
      background-color: transparent;
      color: #fff;
    }
    .anticon {
      color: #a2a5ae;
    }
  }

  /deep/.ant-input-password {
    background-color: #222222;
    border: none;
    border-radius: 8px;

    .ant-input {
      background-color: transparent;
      color: #fff;
    }

    .anticon {
      color: #a2a5ae;
    }
  }
}
.buttonCodeClass {
  font-size: 18px;
}

.register-box {
  width: 320px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 400;
  font-size: 14px;
  margin-bottom: 10px;
  position: relative;
  // bottom: 30px;
  padding: 0px 5px;

  .register-code {
    a {
      color: #ffffff;
    }
  }
}

.sbmitBtn {
  width: 360px;
  height: 40px;
  background: #0166fc;
  border-radius: 8px 8px 8px 8px;
}
.codeInput {
  /deep/.anticon-close-circle {
    margin-right: 5px;
  }
}

.send-code {
  cursor: pointer;
}

/deep/.ant-form-item-label > label {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  font-size: 14px;
  color: #a2a5ae;
}
</style>
